import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// NEW
import {
  LayoutDashboard,
  ShoppingBag,
  FolderTree,
  Settings,
  Users,
  LogOut,
  History,
  ShoppingCart,
  MessageSquare,
  Bell,
  MessagesSquare,
  FileText,
  AlertTriangle,
  UserCog,
  Sparkles,
  Mail,
  Tag,
} from "lucide-react";

import "../../assests/css/admin/AdminSidebar.css";

const getIsSuperAdmin = () => {
  try {
    return Number(JSON.parse(localStorage.getItem("adminUser"))?.issuperadmin) === 1;
  } catch {
    return false;
  }
};

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const activeMenu =
    location.pathname === "/admin" || location.pathname === "/admin/"
      ? "/admin/dashboard"
      : location.pathname;

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMobileOpen) {
      document.body.classList.add("adminsidebar-open");
    } else {
      document.body.classList.remove("adminsidebar-open");
    }
    return () => {
      document.body.classList.remove("adminsidebar-open");
    };
  }, [isMobileOpen]);

  const menuItems = [

    { 
      label: "Dashboard", 
      icon: LayoutDashboard, 
      path: "/admin/dashboard" 
    },
    { 
      label: "Subadmin", 
      icon: UserCog, 
      path: "/admin/subadmin",
      superAdminOnly: true
    },
    { 
      label: "Categories", 
      icon: FolderTree, 
      path: "/admin/categories" 
    },
    { 
      label: "Products", 
      icon: ShoppingBag, 
      path: "/admin/product-management" 
    },
    // { 
    //   label: "Payments", 
    //   icon: CreditCard, 
    //   path: "/admin/payments" 
    // },
    { 
      label: "Order History", 
      icon: History, 
      path: "/admin/orders" 
    },
    { 
      label: "AI Features", 
      icon: Sparkles, 
      path: "/admin/ai-features" 
    },
    { 
      label: "Customer", 
      icon: Users, 
      path: "/admin/customer-management" 
    },
    // { 
    //   label: "Analytics", 
    //   icon: BarChart3, 
    //   path: "/admin/analytics" 
    // },
   
    { 
      label: "Sale", 
      icon: Tag, 
      path: "/admin/sales" 
    },
    { 
      label: "Feedback", 
      icon: MessageSquare, 
      path: "/admin/feedback" 
    },
    { 
      label: "Blogs", 
      icon: FileText, 
      path: "/admin/blogs" 
    },
    // { 
    //   label: "Subscribers", 
    //   icon: UserPlus, 
    //   path: "/admin/subscribers" 
    // },
    { 
      label: "Contact Forms", 
      icon: Mail, 
      path: "/admin/contact-forms" 
    },
    { 
      label: "Notifications", 
      icon: Bell, 
      path: "/admin/notifications" 
    },
    // { 
    //   label: "Conversations", 
    //   icon: MessagesSquare, 
    //   path: "/admin/chat" 
    // },
    { 
      label: "Help & Support", 
      icon: AlertTriangle, 
      path: "/admin/disputes" 
    },
    // { 
    //   label: "Help & Support", 
    //   icon: HelpCircle, 
    //   path: "/admin/help-support" 
    // },
    { 
      label: "Settings", 
      icon: Settings, 
      path: "/admin/store-setting" 
    },

 // NEW
  ];

  const isSuperAdmin = getIsSuperAdmin();
  const visibleMenuItems = menuItems.filter(
    (item) => !item.superAdminOnly || isSuperAdmin
  );

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminemail");
    localStorage.removeItem("adminUser");
    navigate("/admin/login", { replace: true });
  };

  const handleMenuClick = (path) => {
    navigate(path);
    setIsMobileOpen(false);
  };

  return (
    <>
      {/* Hamburger */}
      <button
        className={`adminsidebar-hamburger-button ${
          isMobileOpen ? "adminsidebar-hamburger-open" : ""
        }`}
        onClick={() => setIsMobileOpen((prev) => !prev)}
        aria-label="Toggle Menu"
      >
        <div className="adminsidebar-hamburger-icon">
          <span className="adminsidebar-hamburger-line" />
          <span className="adminsidebar-hamburger-line" />
          <span className="adminsidebar-hamburger-line" />
        </div>
      </button>

      {/* Overlay */}
      <div
        className={`adminsidebar-overlay ${
          isMobileOpen ? "adminsidebar-overlay-active" : ""
        }`}
        onClick={() => setIsMobileOpen(false)}
      />

      {/* Sidebar */}
      <aside
        className={`adminsidebar-container ${
          isMobileOpen ? "adminsidebar-mobile-open" : ""
        }`}
      >
        {/* Logo */}
        <div className="adminsidebar-header">
          <div className="adminsidebar-logo-container">
            <ShoppingCart className="adminsidebar-logo-icon" size={26} />
            <span className="adminsidebar-logo-text">MOONLIT</span>
          </div>
        </div>

        {/* Menu */}
        <nav className="adminsidebar-menu">
          <div className="adminsidebar-menu-section">
            <span className="adminsidebar-menu-label">Main Menu</span>
            <div className="adminsidebar-menu-items">
              {visibleMenuItems.map((item) => {
                const Icon = item.icon;
                const isActive = activeMenu.startsWith(item.path);

                return (
                  <div key={item.path} className="adminsidebar-menu-item-wrapper">
                    <button
                      className={`adminsidebar-menu-item ${
                        isActive ? "adminsidebar-menu-item-active" : ""
                      }`}
                      onClick={() => handleMenuClick(item.path)}
                    >
                      {Icon && <Icon className="adminsidebar-menu-icon" size={20} />}
                      <span className="adminsidebar-menu-text">{item.label}</span>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </nav>

        {/* Logout */}
        <div className="adminsidebar-logout-section">
          <button onClick={handleLogout} className="adminsidebar-logout-btn">
            <LogOut className="adminsidebar-logout-icon" size={20} />
            <span className="adminsidebar-logout-text">Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;